/**
 * ManageVPE Header Component
 * Displays the header with navigation and branding
 * Extracted from ManageVPE.tsx for better modularity
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Plus } from 'lucide-react';

interface ManageVPEHeaderProps {
  onBack: () => void;
  onAddVPE: () => void;
}

const ManageVPEHeader: React.FC<ManageVPEHeaderProps> = ({ onBack, onAddVPE }) => {
  return (
    <div className="bg-gradient-to-r from-purple-100 to-pink-100 border-b border-purple-200 relative z-10">
      <div className="flex items-center justify-between px-8 py-6">
        <div className="flex items-center space-x-4">
          <Button
            onClick={onBack}
            variant="ghost"
            size="sm"
            className="text-purple-600 hover:text-purple-900 hover:bg-purple-200 transition-all duration-200"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Back
          </Button>
          <div className="h-6 w-px bg-purple-300" />
          <img
            src="/lovable-uploads/6823d161-b5be-421b-863a-12eaf2ea796e.png"
            alt="HBox Logo"
            className="h-8 w-auto"
          />
          <div className="text-xl font-semibold text-purple-900">
            <div>PEP</div>
            <div>VPE Admin Dashboard - Manage VPE</div>
          </div>
        </div>
        
        {/* Add VPE Button */}
        <div className="flex items-center">
          <Button
            onClick={onAddVPE}
            className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-6 py-2.5 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add VPE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManageVPEHeader;